import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import {
  DataGrid,
  koKR
} from '@mui/x-data-grid';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiService } from '../../api/axiosClient';
import CustomAvatar from '../../components/mui/avatar';
import CustomChip from '../../components/mui/chip';
import Spinner from '../../components/spinner';
import CustomNoRowsOverlay from '../../utils/CustomNoRowsOverlay';
import { getInitials } from '../../utils/get-initials';
import StaffToolbar from './StaffToolbar';

// ** renders client column
const renderClient = params => {
  const { row } = params
  const stateNum = Math.floor(Math.random() * 6)
  const states = ['success', 'error', 'warning', 'info', 'primary', 'secondary']
  const color = states[stateNum]

  return (
    <CustomAvatar skin='light' color={color} sx={{ mr: 3, fontSize: '.8rem', width: '1.875rem', height: '1.875rem' }}>
      {getInitials(row.name ? row.name : 'User')}
    </CustomAvatar>
  )
}

const statusObj = {
  'ROLE_ADMIN': { title: '관리자', color: 'error' },
  'ROLE_MANAGER': { title: '매니저', color: 'info' }
}

const currencyLocale = Intl.NumberFormat('ko-KR')

const TableStaff = props => {
  const { reload, setReload, selected, setSelected } = props
  const [loading, setLoading] = useState(true)
  const [list, setList] = useState([])

  const loadStaffs = async () => {
    try {
      const response = await apiService.get('/staff');
      
      setList(response.data.list);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    loadStaffs()
  }, [reload])

  const columns = [
    {
      minWidth: 240,
      field: 'username',
      headerName: 'User ID',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {renderClient(params)}
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Link to={`/admin/staff/${row.userid}`}>
                <Typography variant='body2' sx={{ color: 'text.primary', fontWeight: 600 }}>
                  {row.username}
                </Typography>
              </Link>
  
              <Typography variant='caption'>
                {row.email}
              </Typography>
            </Box>
          </Box>
        )
      }
    },
    {
      minWidth: 150,
      field: 'name',
      headerName: '이름',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.name}
        </Typography>
      )
    },
    {
      minWidth: 150,
      field: 'task_code',
      headerName: '담당업무코드',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.task_code}
        </Typography>
      )
    },
    {
      minWidth: 150,
      field: 'task_charge',
      headerName: '담당업무',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.task_charge}
        </Typography>
      )
    },
    {
      minWidth: 150,
      field: 'task_section',
      headerName: '담당업체',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.task_section}
        </Typography>
      )
    },
    {
      minWidth: 150,
      field: 'phone',
      headerName: '연락처',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.phone}
        </Typography>
      )
    },
    {
      minWidth: 100,
      field: 'role',
      headerName: 'role',
      renderCell: params => {
        const status = statusObj[params.row.role]
  
        return (
          <CustomChip
            size='small'
            skin='light'
            color={status.color}
            label={status.title}
            sx={{ '& .MuiChip-label': { textTransform: 'capitalize' } }}
          />
        )
      }
    },
    {
      minWidth: 150,
      field: 'task_target',
      headerName: '매출목표',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {currencyLocale.format(params.row.task_target)}
        </Typography>
      )
    },
    {
      minWidth: 150,
      field: 'regtime',
      headerName: '등록날짜',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {moment(params.row.regtime).format("YYYY-MM-DD")}
        </Typography>
      )
    },
  ]

  return (
    loading ? <Spinner/> :
    <Card>
      <CardHeader title='Staff' />
      <DataGrid
        sx={{
          ...((list?.length || 0) == 0 && { '& .MuiDataGrid-virtualScrollerContent': {height: '200px !important' } })
        }}
        localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
        autoHeight
        getRowId={row => row.userid}
        pagination
        rows={list || []}
        rowCount={list?.length || 0}
        columns={columns}
        onPageChange={newPage => setPage(newPage)}
        components={{
          Toolbar: StaffToolbar,
          NoRowsOverlay: CustomNoRowsOverlay,
        }}
        componentsProps={{
          toolbar: {
            numSelected: selected?.length || 0,
            selected,
            setReload
          }
        }}
        checkboxSelection
        onSelectionModelChange={(ids) => {
          const selectedIDs = new Set(ids);
          const selectedRows = (list || []).filter((row) =>
            selectedIDs.has(row.userid),
          );

          setSelected(selectedRows)
        }}
      />
    </Card>
  )
}

export default TableStaff